import 'css-chunk:src/App.module.scss';export default {
  "contentWrapper": "_contentWrapper_1ls1p_1",
  "eventSelection": "_eventSelection_1ls1p_8",
  "calendar": "_calendar_1ls1p_16"
};